import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseWriters() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      author: isEmpty(state.author),
    };

    setter(errorState);
    if (errorState.author) {
      enqueueSnackbar("لطفا نام نویسنده را وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetWriters = (bool, callback) => {
    MyAxios.get(`Admin_Authors?w=`, {
      headers: {
        IsPage: bool ? true : false,
        Conditions: JSON.stringify({ pageCondition: {} }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetAllAuthors = (callback) => {
    let myPC = {
      PageCount: 1,
    };
    MyAxios.get(`Admin_Authors?w=`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetWriterByID = (WriterID, callback) => {
    MyAxios.get(`Admin_Authors/${WriterID}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const AddWriter = (Model, avatar, background, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    if (background) {
      data.append("background", background);
    }
    if (avatar) {
      data.append("avatar", avatar);
    }
    MyAxios.post(`Admin_Authors`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("افزودن نویسنده باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const UpdateWriter = (Model, avatar, background, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));

    if (background) {
      data.append("background", background);
    }
    if (avatar) {
      data.append("avatar", avatar);
    }
    MyAxios.put(`Admin_Authors`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("ویرایش نویسنده باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const DeleteWriter = (AuthorID, callback) => {
    const data = new FormData();
    data.append("AuthorID", AuthorID);
    MyAxios.delete(`Admin_Authors`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("حذف نویسنده باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  return {
    GetWriters,
    GetWriterByID,
    validate,
    AddWriter,
    UpdateWriter,
    DeleteWriter,
  };
}
